const DAYS_IN_WEEK = 7;
const DAYS_IN_MONTH = 30;
const LONG_TERM_FIRST_RANGE_COEFFICIENT = 2.92 as const;
const LONG_TERM_SECOND_RANGE_COEFFICIENT = 1.7 as const;
const IL_300_RANGE_COEFFICIENT = 0.03083 as const;

const DAYS_FOR_CALCULATE_RATE = 14;
const DAYS_IN_YEAR = 365;

// @link https://sravni-corp.atlassian.net/wiki/spaces/MOB/pages/1076756624#%D0%AD%D0%BB%D0%B5%D0%BC%D0%B5%D0%BD%D1%82-%E2%80%9D%D0%A0%D0%B0%D1%81%D1%87%D0%B5%D1%82%E2%80%9D
export const calculateLongDebt = (amount: number, term: number, rate: number): number => {
  const ratePerTerm = (rate / DAYS_IN_YEAR) * DAYS_FOR_CALCULATE_RATE;
  const numerator = ratePerTerm * amount;
  const denominator = 1 - (1 + ratePerTerm) ** (-term / 2);
  return Math.round(numerator / denominator);
};
export const calculateShortDebt = (amount: number, term: number) => amount + (term * 0.8 * amount) / 100;
/**
 * Расчет аннуитетного платежа по кредиту
 * Формула: Платеж = Сумма × Ставка / (1 - (1 + Ставка)^-Срок)
 *
 * @param loanAmount - Сумма кредита
 * @param monthlyRate - Месячная процентная ставка (в долях единицы, например 0.01 для 1%)
 * @param months - Срок кредита в месяцах
 * @param rounding - Округление до указанного количества знаков (по умолчанию 2)
 * @returns Ежемесячный аннуитетный платеж
 */
export function calculateAnnuityPayment(principal: number, months: number, monthlyRate: number): number {
  return (principal * monthlyRate) / (1 - (1 + monthlyRate) ** -months);
}

export function calculatePayment(amount: number, term: number) {
  if (amount > 100_000) {
    return calculateAnnuityPayment(amount, Math.round(term / DAYS_IN_MONTH), IL_300_RANGE_COEFFICIENT);
  }

  if (amount > 70_000 && amount <= 100_000) {
    return calculateLongDebt(amount, Math.round(term / DAYS_IN_WEEK), LONG_TERM_SECOND_RANGE_COEFFICIENT);
  }

  return calculateLongDebt(amount, Math.round(term / DAYS_IN_WEEK), LONG_TERM_FIRST_RANGE_COEFFICIENT);
}
